import { Box, Typography, Menu, MenuItem, Link as MuiLink } from "@mui/material"
import { useTranslation } from "react-i18next"
import { Link } from "react-router-dom"
import { useState } from "react"
import { version } from "../../../config/version"
import { usePermissions } from "../../../features/auth/hooks/usePermissions"
import { ONBOARDING_SCOPES } from "../../../features/onboarding/onboardingScopes"
import { TEST_BARCODE_SCOPES } from "../../../features/inventory/scannerScopes"

// Pages with no menu entry, reached by clicking the version number five times
// (only those the user may open)
const HIDDEN_PAGES = [
  { to: "/setup/download", label: "common:navigation.setup_staff_template", scopes: ["staff:create"] },
  { to: "/setup/parse", label: "common:navigation.setup_staff_import", scopes: ["staff:create"] },
  { to: "/onboarding", label: "common:navigation.onboarding", scopes: ONBOARDING_SCOPES },
  { to: "/inventory/test-barcodes", label: "common:navigation.inventory_test_barcodes", scopes: TEST_BARCODE_SCOPES },
]

export const VersionMenu = () => {
  const { t } = useTranslation(["common"])
  const { hasAllScopes } = usePermissions()
  const hiddenPages = HIDDEN_PAGES.filter(({ scopes }) => hasAllScopes(scopes))
  const [clickCount, setClickCount] = useState(0)
  const [anchorEl, setAnchorEl] = useState(null)

  const handleClick = (event) => {
    const newCount = clickCount + 1
    setClickCount(newCount)
    
    if (newCount === 5) {
      setAnchorEl(event.currentTarget)
      setClickCount(0)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const getVersionText = () => {
    const baseVersion = t("common:version", {version: version})
    if (clickCount >= 3) {
      return `${baseVersion} (${5 - clickCount})`
    }
    return baseVersion
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
      <Typography 
        variant='caption' 
        onClick={handleClick}
        sx={{ cursor: 'default', userSelect: "none" }}
      >
        {getVersionText()}
      </Typography>
      <MuiLink component={Link} to="/changelog" variant="caption" underline="hover" color="text.secondary">
        {t("common:navigation.changelog")}
      </MuiLink>
      
      <Menu
        anchorEl={anchorEl}
        open={Boolean(anchorEl)}
        onClose={handleClose}
      >
        {hiddenPages.map(({ to, label }) => (
          <MenuItem key={to} component={Link} to={to} onClick={handleClose}>
            {t(label)}
          </MenuItem>
        ))}
      </Menu>
    </Box>
  )
}